import React from 'react';
import { Link } from 'gatsby';
import Loadable from '@loadable/component';

import './partner.styles.scss';

const Pulse = Loadable(() => import('react-reveal/Pulse'));

const partners = [
  require('../../assets/photos/hopin-partners/durham.png'),
  require('../../assets/photos/hopin-partners/hrprimed.png'),
  require('../../assets/photos/hopin-partners/jll-hotel.png'),
  require('../../assets/photos/hopin-partners/markham.png'),
  require('../../assets/photos/hopin-partners/vaughan.png'),
];

const Partner: React.FC = () => {
  return (
    <div className="why-hopin">
      <div className="container">
        <Pulse>
          <div className="section-title">
            <span className="sub-title">Why Hop In?</span>
            <h2>Revolutionizing Transportation Logistics</h2>
          </div>
        </Pulse>

        <div className="row">
          <Pulse>
            <div className="col-lg-6 col-md-12">
              <div className="why-hopin-content">
                <h2>Why Choose Us?</h2>
                <p>
                  Hop In offers a customized and sustainable solution for the
                  daily commute.
                </p>
                <p>
                  We help companies save money, reduce their carbon footprint,
                  and improve employee retention rates.
                </p>
                <Link to="/about-us" className="default-btn">
                  <i className="flaticon-right"></i>
                  More on Who We Are <span></span>
                </Link>

                <div className="map-shape">
                  <img src={require('../../assets/map/map-bg.png')} alt="map" />
                </div>
              </div>
            </div>
          </Pulse>

          <Pulse>
            <div className="col-lg-6 col-md-12">
              <div className="hopin-partners-list">
                <h2>Our Supporters</h2>
                <div className="row align-items-center">
                  {partners.map((partner, i) => (
                    <div className="col-lg-6 col-sm-6 col-md-4" key={i}>
                      <img src={partner} alt="partner" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Pulse>
        </div>
      </div>
    </div>
  );
};

export default Partner;
